import moment from "moment"
import React, {useEffect, useState} from "react"
import styled from "styled-components"
import { AppButton } from "ui/base/appButton/AppButton"
import { ButtonPrimary } from "ui/base/Button/ButtonStyled"
import { HelperText } from "ui/base/helperText/HelperText"
import { InputSignUp } from "ui/base/InputSignUp/InputSignUp"
import { Modal } from "ui/base/modal/Modal"
import { numberOnly } from "utils"
import {hasTimeConflict} from "utils/schedule-utils";

export const ClassDurationModal = ({
  handleClose,
  show,
  onAddClassDuration,
  currentClassDuration,
  classAvailability,
}) => {
  const [classDuration, setClassDuration] = useState(currentClassDuration)
  const [formErrors, setFormErrors] = useState({
    classDuration: "",
    classConflict: "",
  })

    useEffect(() => {
        if(currentClassDuration){
            setClassDuration(currentClassDuration)
        }
    },[currentClassDuration,show])

  const handleClassDurationChange = (value) => {
    setClassDuration(value)
    setFormErrors((prev) => ({
      ...prev,
      classDuration:
        +value < 30 ? "Class duration must be at least 30 minutes" : "",
    }))
  }

  const resetForm = () => {
    setFormErrors({})
    setClassDuration(null)
    handleClose?.()
  }

  const handleAddClassDuration = () => {
    if (!classDuration || formErrors.classDuration) {
      setFormErrors((prev) => ({
        ...prev,
        classDuration: prev.classDuration ?? "Must be filled",
      }))
      return
    }

    const isTimeError = hasTimeConflict(classAvailability,classDuration)

    if (isTimeError) {
      setFormErrors((prev) => ({
        ...prev,
        classConflict:
          "Separation between classes is shorter than class duration",
      }))
    } else {
      onAddClassDuration?.(classDuration)
      resetForm()
    }
  }

  return (
    <Modal show={show} handleClose={resetForm} maxWidth={415} minHeight={100}>
      <Container>
        <InputBlockContainer>
          <HelperText center>How long does the class last?</HelperText>
          <ErrorContainer>
            <ProfileButtonContainer>
              <InputContainer>
                <InputSignUp
                  onInput={numberOnly}
                  placeholderPosition={'center'}
                  placeholder='Add minutes'
                  maxLength={3}
                  setValue={handleClassDurationChange}
                  value={classDuration}
                  isError={formErrors?.classDuration}
                  inputCenterText
                />
              </InputContainer>
              <AppButton
                variant
                height={"100%"}
                style={{ pointerEvents: "none" }}>
                Minutes
              </AppButton>
            </ProfileButtonContainer>
            {formErrors?.classDuration ? (
              <HelperText color='pink'>{formErrors?.classDuration}</HelperText>
            ) : null}
            {formErrors?.classConflict ? (
              <HelperText color='pink'>{formErrors.classConflict}</HelperText>
            ) : null}
          </ErrorContainer>
        </InputBlockContainer>
        <ButtonPrimary onClick={handleAddClassDuration}>
          Select Duration
        </ButtonPrimary>
      </Container>
    </Modal>
  )
}

const InputBlockContainer = styled.div`
  display: grid;
  gap: 35px;
`

const Container = styled.div`
  display: grid;
  gap: 1rem;
`

const ProfileButtonContainer = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
`

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
const InputContainer = styled.div`
  text-align: center;
`
